import { useContextSelector } from 'use-context-selector';
import { EdiAdminContext } from './EdiAdminContext';
import Outstanding810LogsView from './Outstanding810LogsView';
import TimingLogsView from './TimingLogsView';

const ToggleEdiAdminView = () => {
  const selectedView = useContextSelector(EdiAdminContext, (ctx) => ctx.selectedView);

  return (
    <div className="grid-area-main min-h-0 overflow-y-auto" style={{ zIndex: 10 }}>
      {selectedView === 0 ? <TimingLogsView /> : <Outstanding810LogsView />}
    </div>
  );
};

export default ToggleEdiAdminView;
